import base from './base'

let controller = 'city'
let action = null

const City = {
  async listCities (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    querys.isVisible = query.isVisible !== null ? query.isVisible ? true : false : null
    action = 'ListCities'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async addCity (request) {
    let model = {
      name: request.name || null,
      code: request.code || null,
      tier: request.tier || 1,
      isVisible: request.isVisible || true
    }
    action = 'Create'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async updateCity (request) {
    let model = {
      id: request.id || request.tid || null,
      name: request.name || null,
      code: request.code || null,
      tier: request.tier || 1,
      isVisible: request.isVisible || true
    }
    if (!model.id) {
      throw new Error('提交数据不合法!ID为空')
    }
    action = `Update/${model.id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async deleteCity (cityId) {
    if (!cityId) {
      throw new Error('CityId为空')
    }
    action = `Delete/${cityId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getCityName (cityId) {
    if (!cityId) {
      throw new Error('CityId为空')
    }
    action = `GetCityName/${cityId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  }
}

export default City